//상담원 연결 가능 시간 확인용 API
const { REACT_APP_CONTEXT_PATH } = process.env;

export const checkAssignTimeApi = () => {
  return {
    apiUrl: REACT_APP_CONTEXT_PATH + `/branch/not-assign-times`,
  };
};
